import { useState, React, useEffect } from "react";
import {
    Container, Grid, Typography, TextField, Box,
    FormControl, InputLabel, Select, MenuItem, FormControlLabel,
    RadioGroup, Radio, Accordion, AccordionActions, Button, AccordionSummary, Dialog, DialogActions, DialogTitle,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton"
import SearchIcon from '@mui/icons-material/Search';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import globals from "../globals";
import { useAuth } from "../context/AuthContext"
import { useNavigate, useLocation } from "react-router-dom";

const CoursePage = () => {

    const { token } = useAuth()
    const navigate = useNavigate();
    const location = useLocation();

    const [searchField, setSearchField] = useState('course');
    // const [coursesState, setCoursesState] = useState(courses);
    const [radioFilter, setRadioFilter] = useState('all')
    const [filter, setFilter] = useState('');
    const [openDialog, setOpenDialog] = useState(null); // Track which course's dialog is open (course ID or null)
    const [coursesState, setCoursesState] = useState([]);
    const [loadingStates, setLoadingStates] = useState({}); // Track loading by courseId and button type

    const fetchCourses = () => {
        fetch(globals.apiUrl + '/admin/courses', {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then(data => {
                setCoursesState(data);
            })
            .catch(error => {
                console.error('Error:', error);
            })
    };

    useEffect(() => {
        fetchCourses();
    }, []);

    useEffect(() => {
        fetchCourses();
    }, [location.key]);

    const handleClickOpenDialog = (courseId) => {
        setOpenDialog(courseId);
    };

    const handleCloseDialog = () => {
        setOpenDialog(null);
    };

    const handleSetSearchField = (event) => {
        setSearchField(event.target.value)
    }

    const handlePublishedChange = (id, is_published) => {
        const buttonType = is_published ? 'publish' : 'draft';
        setLoadingStates(prev => ({ ...prev, [`${id}-${buttonType}`]: true }));

        fetch(globals.apiUrl + `/admin/courses/${id}/${(is_published) ? "publish" : "draft"}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                setCoursesState(prevCourses =>
                    prevCourses.map(course =>
                        course.id === data.id ? { ...course, is_published: data.is_published } : course
                    )
                );
                setLoadingStates(prev => ({ ...prev, [`${id}-${buttonType}`]: false }));
            })
            .catch(error => {
                console.error('Error:', error);
                setLoadingStates(prev => ({ ...prev, [`${id}-${buttonType}`]: false }));
            })
    }

    const handleApproveCourse = (id) => {
        setLoadingStates(prev => ({ ...prev, [`${id}-approve`]: true }));

        fetch(globals.apiUrl + `/admin/courses/${id}/approve`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
            .then(response => response.json())
            .then(data => {
                setCoursesState(prevCourses =>
                    prevCourses.map(course => course.id === data.id ? { ...course, is_approved: data.is_approved } : course)
                );
                setLoadingStates(prev => ({ ...prev, [`${id}-approve`]: false }));
            })
            .catch(error => {
                console.error('Error:', error);
                setLoadingStates(prev => ({ ...prev, [`${id}-approve`]: false }));
            })
    }

    const handleDeleteCourse = (id) => {
        setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: true }));

        fetch(globals.apiUrl + `/admin/courses/${id}/delete`,
            {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }
        )
            .then(response => response.json())
            .then(data => {
                setCoursesState(prevCourses => prevCourses.filter(course => course.id != id))
                setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: false }));
            })
            .catch(error => {
                console.error('Error:', error);
                setLoadingStates(prev => ({ ...prev, [`${id}-delete`]: false }));
            })
    }

    const filterFunction = () => {
        let result = []

        if (searchField == 'course') {
            result = coursesState.filter(course => course.title.toLocaleLowerCase().includes(filter.toLocaleLowerCase()))
        }
        else {
            result = coursesState.filter(course => course.instructor_name.toLocaleLowerCase().includes(filter.toLocaleLowerCase()))
        }

        if (radioFilter == 'active') {
            result = result.filter(course => course.is_published)
        } else if (radioFilter == 'draft') {
            result = result.filter(course => !course.is_published)
        }

        return result
    }

    return (
        <Container>
            <Grid container>
                <Grid item sm={6}>
                    <Typography sx={{ fontWeight: 'bold', fontSize: 25, textTransform: 'uppercase' }}>
                        Курсове
                    </Typography>
                </Grid>
                <Grid item sx={{ mr: 5 }}>
                    <Box sx={{ minWidth: 120 }}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Курсове</InputLabel>
                            <Select
                                value={searchField}
                                label="Курсове"
                                onChange={handleSetSearchField}
                            >
                                <MenuItem value={'course'}>Курсове</MenuItem>
                                <MenuItem value={'instructor'}>Учители</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Grid>
                <Grid item sm={4}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                        <SearchIcon fontSize='large' sx={{ color: 'action.active', mr: 1, my: 1 }} />
                        <TextField placeholder="Търсене" onChange={(event) => setFilter(event.target.value)} />
                    </Box>
                </Grid>
            </Grid>

            <Grid>
                <FormControl onChange={(event) => { setRadioFilter(event.target.value) }}>
                    <RadioGroup
                        defaultValue="all"
                    >
                        <Grid container>
                            <Grid item>
                                <FormControlLabel value="all" control={<Radio />} label="Всички" />
                            </Grid>
                            <Grid item>
                                <FormControlLabel value="active" control={<Radio />} label="Активни" />
                            </Grid>
                            <Grid item>
                                <FormControlLabel value="draft" control={<Radio />} label="Чернова" />
                            </Grid>
                        </Grid>
                    </RadioGroup>
                </FormControl>
            </Grid>

            <Grid container sx={{ mt: 2 }} spacing={1}>
                {filterFunction().map(course => (
                    <Grid item sm={12} key={course.id}>
                        <Accordion fullWidth>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography component="span"> <strong>{course.title}</strong> | {course.instructor_name} | <span style={{ 'color': course.is_published ? "green" : "red" }} > {course.is_published ? "Активен" : "Чернова"}</span> | {course.is_approved ? "Одобрен" : "Не одобрен"}</Typography>
                            </AccordionSummary>
                            <AccordionActions>
                                <LoadingButton loading={loadingStates[`${course.id}-approve`] || false} onClick={() => handleApproveCourse(course.id)} >Одобри</LoadingButton>
                                <LoadingButton loading={loadingStates[`${course.id}-publish`] || false} onClick={() => handlePublishedChange(course.id, true)}>Публикувай</LoadingButton>
                                <LoadingButton loading={loadingStates[`${course.id}-draft`] || false} onClick={() => handlePublishedChange(course.id, false)}>Чернова</LoadingButton>
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    onClick={() => navigate(`/admin-edit-course/${course.id}`)}
                                >
                                    Редактирай
                                </Button>
                                <LoadingButton loading={loadingStates[`${course.id}-delete`] || false} onClick={() => handleClickOpenDialog(course.id)} variant="contained" color='error'>Изтрий</LoadingButton>
                                <Dialog
                                    open={openDialog === course.id}
                                    onClose={handleCloseDialog}
                                >
                                    <DialogTitle id="alert-dialog-title">
                                        {"Искате ли да изтриете този курс?"}
                                    </DialogTitle>
                                    <DialogActions>
                                        <Button onClick={() => {
                                            handleDeleteCourse(course.id);
                                            handleCloseDialog();
                                        }}>Да</Button>
                                        <Button onClick={handleCloseDialog} autoFocus>
                                            Не
                                        </Button>
                                    </DialogActions>
                                </Dialog>
                            </AccordionActions>
                        </Accordion>
                    </Grid>
                ))}
            </Grid>
        </Container>
    );
}

export default CoursePage
